import React, { useEffect, useState } from 'react'
import {
  SplashContainer,
  SplashImage,
  LogoContainer,
  VideoBox,
  Overlay
} from './style'
import { useNavigate } from 'react-router-dom'
import { universe } from 'shared-ui/assets'
import { Text, Button } from 'shared-ui/components'
import { useLandingPage, useResponsive } from 'shared-ui/hooks'
import { useLanguage } from 'shared-ui/utils/languageProvider'
import Player from '../../../../../apps/super-app/src/pages/Player'
import { ALT_SPLASH_LOGO, ROUTES, SPLASH_SCREEN_TEXT } from 'shared-ui/utils/constants'
import PromoContainer from './promo.jsx'
import { setGuestUser } from 'shared-ui/utils/localStorage.js'
import { media } from 'shared-ui/utils/media.js'

const Splash = () => {
  const { data: landingPageData } = useLandingPage()
  // Subscribe to language changes so splash texts re-render when language changes
  const { language } = useLanguage()
  const [isPromoScreen, setpromoScreen] = useState(true)
  const isMobile = useResponsive(media.mobile)

  const navigate = useNavigate()
  const landingPageVideo =
    (landingPageData &&
      landingPageData.data &&
      landingPageData.data[0] &&
      landingPageData?.data[0].file_url) ||
    ''

  const onEnter = () => {
    navigate(ROUTES.login)
  }

  const onCreateAcc = () => {
    navigate(ROUTES.register)
  }

  const onGuestUserClick = () => {
    setGuestUser(true)
   navigate('/super-app-home')
  }
  // Call the global play function when component mounts
  useEffect(() => {
    const playVideo = () => {
      if (window.playSplashVideo) {
        window
          .playSplashVideo()
          .then(() => {
            // Splash video started playing
          })
          .catch((error) => {
            // Retry after a delay if player wasn't ready
            if (error.message === 'Player not ready') {
              setTimeout(playVideo, 1000)
            }
          })
      } else {
        // Retry after a short delay if the function isn't available yet
        setTimeout(playVideo, 500)
      }
    }

    // Check if device is iPad/tablet
    const isTablet = /iPad|Android(?!.*Mobile)|Tablet/i.test(
      navigator.userAgent
    )

    // Wait longer for tablets to initialize
    const initialDelay = isTablet ? 2000 : 1000
    setTimeout(playVideo, initialDelay)
  }, [])

  const showPromoScreen = () => {
    setpromoScreen(true)
  }

  return (
    <SplashContainer>
      {!isMobile && <Overlay />}
      <VideoBox>
        <Player
          videoUrl={landingPageVideo}
          className="splash-player-bg"
          muted={true}
          autoplay={false}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 0,
            pointerEvents: 'none',
            background: 'black',
            minWidth: '100vw',
            minHeight: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            objectFit: 'cover'
          }}
        />
      </VideoBox>
      {isPromoScreen ? (
        <PromoContainer
          createAccountClick={onCreateAcc}
          signInclick={onEnter}
          guestUserClick={onGuestUserClick}
        />
      ) : (
        <>
          <LogoContainer>
            <SplashImage src={universe} alt={ALT_SPLASH_LOGO} />
            <Text as="h1" fontSize={'28px'}>
              {SPLASH_SCREEN_TEXT.TITLE}
            </Text>
            <Button
              onClick={showPromoScreen}
              width="200px"
              height="48px"
              maxWidth="340px"
              padding="10px"
              borderRadius="24px"
              fontSize="14px"
              fontWeight={600}
            >
              {SPLASH_SCREEN_TEXT.ENTER_LABEL}
            </Button>
          </LogoContainer>
          <Text
            splashSubtitle
            gradientText
            fontSize={'24px'}
            fontWeight={600}
            marginBottom={'30px'}
          >
            {SPLASH_SCREEN_TEXT.SUBTITLE}
          </Text>
        </>
      )}
    </SplashContainer>
  )
}

export default Splash
